import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import FileImport from "components/FileImport";
import { confirmPromptLibraryOverwrite } from "components/Modal/confModalTypes";
import RadioCards from "components/RadioCards";
import { modalTypes } from "constants/types";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal, showModal } from "slices/app/actions/modals";
import { importPromptsFromCSV } from "slices/prompts/actions";

const IMPORT_MODES = {
  APPEND: "APPEND",
  OVERWRITE: "OVERWRITE",
};

const ImportPromptLibraryCsvModal = () => {
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [importMode, setImportMode] = useState(IMPORT_MODES.APPEND);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0] ?? null);
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.IMPORT_PROMPT_LIBRARY_CSV));
  };

  const runImport = () => {
    dispatch(importPromptsFromCSV(selectedFile, importMode));
  };

  const handleImport = () => {
    if (importMode === IMPORT_MODES.OVERWRITE) {
      dispatch(hideModal(modalTypes.IMPORT_PROMPT_LIBRARY_CSV));
      dispatch(
        showModal(
          modalTypes.CONFIRMATION,
          confirmPromptLibraryOverwrite(runImport, dispatch)
        )
      );
    } else {
      runImport();
      dispatch(hideModal(modalTypes.IMPORT_PROMPT_LIBRARY_CSV));
    }
  };

  return (
    <Modal className="fade-in" show onDismiss={handleCancel} backdrop centered>
      <Modal.Header>Import from text file (CSV)</Modal.Header>
      <Modal.Body>
        <FileImport
          accepts=".csv"
          handleFileChange={handleFileChange}
          selectedFile={selectedFile}
          labelText="Import File"
        />
        <p>Import Options</p>
        <RadioCards
          idPrefix="prompt-import-mode"
          options={[
            {
              label: "Append to existing prompt library",
              value: IMPORT_MODES.APPEND,
            },
            {
              label: "Overwrite existing prompt library",
              value: IMPORT_MODES.OVERWRITE,
            },
          ]}
          onChange={setImportMode}
          value={importMode}
        />
      </Modal.Body>
      <Modal.Footer>
        <NewButton variant={NewButtonVariant.l2} onClick={handleCancel}>
          Cancel
        </NewButton>
        <NewButton
          variant={NewButtonVariant.l1}
          onClick={handleImport}
          disabled={!selectedFile}
        >
          Import
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ImportPromptLibraryCsvModal;
